import { useBreakpoint } from '@/common/hooks/use-breakpoint';
import { useEffect } from 'react';

export function usePDPAssembledPosition() {
  const assembled = typeof window !== 'undefined' ? window.assembled : undefined;
  const breakpoint = useBreakpoint();
  useEffect(() => {
    if (assembled) {
      if (breakpoint === 'desktop') {
        assembled.setPosition({
          anchor: 'bottom-right',
          offsetX: 10,
          offsetY: 10,
        });
      } else {
        assembled.setPosition({
          anchor: 'bottom-right',
          offsetX: 10,
          offsetY: 90,
        });
      }
    }
  }, [assembled, breakpoint]);
}
